import React from 'react';
import { Button } from './button';
import { Loader2 } from 'lucide-react';

/**
 * Reusable action button component with consistent styling
 * Matches the sidebar button rounding (rounded-md)
 */
const ActionButton = ({ 
  onClick, 
  disabled = false, 
  loading = false,
  children,
  variant = 'primary',
  icon: Icon,
  className = '',
  ...props 
}) => {
  const variantStyles = {
    primary: 'bg-blue-600 hover:bg-blue-700 text-white shadow-none',
    secondary: 'bg-gray-100 hover:bg-gray-200 text-gray-900 shadow-none',
    outline: 'border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 shadow-none'
  };

  return (
    <Button
      onClick={onClick}
      disabled={disabled || loading}
      className={`px-8 py-5 text-lg rounded-md font-medium ${variantStyles[variant]} ${className}`}
      {...props}
    >
      {loading ? (
        <>
          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          Loading...
        </>
      ) : (
        <>
          {Icon && <Icon className="w-4 h-4 mr-2" />}
          {children}
        </>
      )}
    </Button>
  );
};

export default ActionButton;
